import { Empty, Modal } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { memo, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { AppTable } from '../../../components/AppTable/AppTable'
import AssetInputUpdate from './AssetInputUpdate'

const AssetStatisticsTable = props => {
  const {
    managementAssetWarehouseStore,
    isLoading,
    reloadList,
    assetStatisticList,
  } = props

  const { pageIndex, sizeIndex } = managementAssetWarehouseStore
  const [isVisibleUpdateModal, setIsVisibleUpdateModal] = useState(false)
  const [assetHistory, setAssetHistory] = useState(null)

  const handleRowClick = record => {
    setAssetHistory(record)
    setIsVisibleUpdateModal(true)
  }

  const handleCancelUpdateModal = () => {
    setIsVisibleUpdateModal(false)
    setAssetHistory(null)
  }

  const handleCloseUpdateModal = () => {
    setIsVisibleUpdateModal(false)
    setAssetHistory(null)
    reloadList()
  }

  const tableColumns = [
    {
      title: 'STT',
      width: '20px',
      render: (id, record, index) => (
        <span title={pageIndex * sizeIndex + index + 1}>
          {pageIndex * sizeIndex + index + 1}
        </span>
      ),
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Tên dụng cụ, văn phòng phẩm',
      width: '80px',
      render: record => {
        return <span>{record?.assetName}</span>
      },
      align: 'left',
      ellipsis: true,
    },
    {
      title: 'Thuế',
      width: '20px',
      render: record => {
        const tax = record?.tax || 0
        return <span>{tax ? tax + '%' : '----'}</span>
      },
      align: 'right',
      ellipsis: true,
    },
    {
      title: 'Đơn giá trước thuế',
      width: '30px',
      render: record => {
        const price = record?.price || 0
        return (
          <span>
            {price ? parseFloat(price).toLocaleString('vi-VN') : '----'}
          </span>
        )
      },
      align: 'right',
      ellipsis: true,
    },
    {
      title: 'Đơn giá sau thuế',
      width: '30px',
      render: record => {
        const price = record?.price || 0
        const tax = record?.tax || 0
        const totalMoney = (price * (tax + 100)) / 100 + ''
        return (
          <span>
            {totalMoney
              ? parseFloat(totalMoney).toLocaleString('vi-VN')
              : '----'}
          </span>
        )
      },
      align: 'right',
      ellipsis: true,
    },
    {
      title: 'Số lượng',
      width: '20px',
      render: record => {
        return <span>{record?.quantity || 0}</span>
      },
      align: 'right',
      ellipsis: true,
    },
    {
      title: 'Thành tiền trước thuế',
      width: '40px',
      render: record => {
        return <span>{record?.preMoney?.toLocaleString('vi-VN')}</span>
      },
      align: 'right',
      ellipsis: true,
    },
    {
      title: 'Thuế xuất',
      width: '40px',
      render: record => {
        return (
          <span>
            {(
              Number(record?.totalMoney) - Number(record?.preMoney)
            )?.toLocaleString('vi-VN')}
          </span>
        )
      },
      align: 'right',
      ellipsis: true,
    },
    {
      title: 'Thành tiền sau thuế',
      width: '40px',
      render: record => {
        return <span>{record?.totalMoney?.toLocaleString('vi-VN')}</span>
      },
      align: 'right',
      ellipsis: true,
    },
  ]

  return (
    <>
      <AppTable
        // scroll={{
        //   x: 2000,
        // }}
        rowKey={record => record.id}
        onRow={record => {
          return {
            onClick: () => handleRowClick(record),
          }
        }}
        bordered
        // @ts-ignore
        dataSource={assetStatisticList}
        // @ts-ignore
        columns={tableColumns}
        pagination={false}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={'Không có dữ liệu'}
            />
          ),
        }}
        loading={isLoading}
      />
      <Modal
        width={700}
        title={'Nhập kho'}
        visible={isVisibleUpdateModal}
        maskClosable={false}
        onCancel={handleCancelUpdateModal}
        footer={null}
        destroyOnClose>
        {isVisibleUpdateModal && (
          <AssetInputUpdate
            onCancel={handleCancelUpdateModal}
            onClose={handleCloseUpdateModal}
            assetHistory={assetHistory}
          />
        )}
      </Modal>
    </>
  )
}

export default memo(
  withRouter(
    inject('managementAssetWarehouseStore')(observer(AssetStatisticsTable))
  )
)
